const IMPORT_TYPES = {
  insert: 'insert',
  update: 'update',
  upsert: 'upsert',
  delete: 'delete',
} as const

export default IMPORT_TYPES
